import { useContext } from 'react';
import { RefreshContext } from 'contexts/RefreshContext';

const useRefresh = () => {
  const { fast, slow, superFast } = useContext(RefreshContext);
  return { fastRefresh: fast, slowRefresh: slow, superFastRefresh: superFast };
};

export default useRefresh;
